<template>
  <div class="time-curve-wrapper">
    <div class="card wrapper" :class="zoomTimeCurveTopDate ? 'zoomed' : ''">
      <div class="card-header">
        <div class="header-title">Publications sur la dernière année</div>
      </div>
      <div v-if="isZoomTimeCurveLoading" class="loading-wrapper">
        <MinerveOrbite />
      </div>
      <NoData v-if="!isZoomTimeCurveLoading && !zoomTimeCurve" />
      <GenericTimeCurve
        v-else-if="!isZoomTimeCurveLoading && zoomTimeCurve"
        :data="zoomTimeCurve"
        :platforms="PLATFORM_TYPES"
        :interval="zoomTimeCurveInterval"
        @update-top-date="updateTopDate"
      />
    </div>
    <div v-if="zoomTimeCurveTopDate" class="zoom-wrapper">
      <GenericTimeCurveZoom
        :interval="zoomTimeCurveInterval"
        :author-id="authorZoom?._id"
        :top-date="zoomTimeCurveTopDate"
        :top-articles="zoomTimeCurveTopArticles"
        :top-articles-filters="zoomTimeCurveTopArticlesFilters"
        :top-publications="zoomTimeCurveTopPublications"
        :top-publications-count="zoomTimeCurveTopPublicationsCount"
        :top-articles-count="zoomTimeCurveTopArticlesCount"
        :is-publications-loading="isTimeCurveZoomPublicationsLoading"
        @update-top-articles-filters="updateTopArticlesFilters"
        @update-publications-filters="updatePublicationsFilters"
        @closes-zoom="closeZoom"
      />
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import MinerveOrbite from "@follaw-fr/components/reusable/minerve/MinerveOrbite.vue";

import GenericTimeCurve from "@follaw-fr/components/reusable/organisms/GenericTimeCurve.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import GenericTimeCurveZoom from "@follaw-fr/components/reusable/organisms/GenericTimeCurveZoom.vue";
import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";
import { PLATFORM_TYPES } from "@follaw-fr/utils/social360-platforms";
import { useTimeCurve } from "@follaw-fr/composables/useTimeCurve";

const store = useStakeholdersStore();
const {
  authorZoom,
  isZoomTimeCurveLoading,
  zoomTimeCurve,
  zoomTimeCurveInterval,
  zoomTimeCurveTopDate,
  zoomTimeCurveTopArticles,
  zoomTimeCurveTopArticlesFilters,
  zoomTimeCurveTopArticlesCount,
  zoomTimeCurveTopPublications,
  zoomTimeCurveTopPublicationsCount,
  isTimeCurveZoomPublicationsLoading,
  zoomTimeCurveTopPublicationsFilters,
} = storeToRefs(store);

const {
  closeZoom,
  updateTopDate,
  updateTopArticlesFilters,
  updatePublicationsFilters,
} = useTimeCurve({
  timeCurve: zoomTimeCurve,
  timeCurveInterval: zoomTimeCurveInterval,
  timeCurveTopDate: zoomTimeCurveTopDate,
  timeCurveTopArticlesFilters: zoomTimeCurveTopArticlesFilters,
  timeCurveTopPublicationsFilters: zoomTimeCurveTopPublicationsFilters,
});
</script>

<style lang="scss" scoped>
.time-curve-wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
}

.wrapper {
  display: flex;
  flex-direction: column;
  grid-column: span 2;

  .card-header {
    display: flex;
    justify-content: space-between;

    .header-title {
      font-size: 1.063em;
      font-weight: 600;
      color: black;
    }

    .header-tools {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  &.zoomed {
    grid-column: span 1;
  }
}

.zoom-wrapper {
  grid-column: span 1;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 400px;
  margin-left: auto;
  margin-right: auto;
}
</style>
